import script from "./CloseClock.vue?vue&type=script&setup=true&lang=js"
export * from "./CloseClock.vue?vue&type=script&setup=true&lang=js"

import "./CloseClock.vue?vue&type=style&index=0&id=5a81cf4d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a81cf4d"]])

export default __exports__